export class RescheduleEligibility {
    quality: number = 0;
    message: string = '';
    isRescheduleEligible: boolean = false;
    orderEffectiveDate: Date;
    scheduleWindow: number;
}

export class AvailabilityRequest {
    ldc: string = '';
    orderNumber: string = '';
    seedDate: string = '';
    premisesNumber: string = '';
    entranceInstructionCode: string = '';
    entranceInstructionProfile: string = '';

    accountNumber: string = '';
    activityOrProblemType: string = '';
    isOverride: boolean = false;
    orderCategory: string = '';    
    serviceOrderActiontype: string = '';
    serviceOrderReason: string = '';
    serviceOrderType: string = '';
    specialDateCodeID: string = '';
}

export class AvailabilityDates {
    availableDate: string = '';
    displayDay: string = '';
    displayDate: string = '';
    enabled: boolean = false;
}

export enum NoGasClickOrderModel {
    GasOffGasOffCompanyWork = "Gas Off#Gas Off Company Work",
    GasOffGasOffCutatCurb = "Gas Off#Gas Off Cut at Curb",
    GasOffGasOffFirePolice = "Gas Off#Gas Off Fire/Police",
    GasOffGasOffinError = "Gas Off#Gas Off in Error",
    GasOffGasOffLoworHighPressure = "Gas Off#Gas Off Low or High Pressure",
    GasOffGasOffOutage = "Gas Off#Gas Off Outage",
    GasOffGasOffVandalism = "Gas Off#Gas Off Vandalism",
    TurnONCustomerConvenience = "Turn ON#Customer Convenience",
    MadeSafeGasOffEmergency = "Made Safe#Gas Off Emergency",
    NoGasUnknown = "No Gas#Unknown"
}

export class AvailabilityInput {
    ldc: string = '';
    kmiUrlCode: string = '';
    orderNumber: string = '';
    orderType: string = '';
    premisesNumber: string = '';
    entranceInstructionCode: string = '';
    entranceInstructionProfile: string = '';
    logReferenceID: string = '';
    portalTypeID: number = 0;
    entranceCodeReminderMsg: string = '';
    emailToList: string = '';
    appointmentType: string = '';

    accountNumber: string = '';
    activityOrProblemType: string = '';
    isOverride: boolean = false;
    orderCategory: string = '';
    serviceOrderActiontype: string = '';
    serviceOrderReason: string = '';
    serviceOrderType: string = '';
    specialDateCodeID: string = '';
}
export class AvailabilityOutput {
    selectedTimeSlot: string = '';    
    selectedScheduleDate: string = '';
    selectedScheduleWindow: string = '';
    selectedTimeSlotWindow: string = '';
    ccbAppointmentStart: string = '';
    ccbAppointmentEnd: string = '';
}